/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Custompropertyrules_WriteInputs */

const en_enum_permission_name_custompropertyrules_write = /** @type {(inputs: Enum_Permission_Name_Custompropertyrules_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Custompropertyrules Write`)
};

const de_enum_permission_name_custompropertyrules_write = /** @type {(inputs: Enum_Permission_Name_Custompropertyrules_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Custompropertyrules Write`)
};

/**
* | output |
* | --- |
* | "Name Custompropertyrules Write" |
*
* @param {Enum_Permission_Name_Custompropertyrules_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_custompropertyrules_write = /** @type {((inputs?: Enum_Permission_Name_Custompropertyrules_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Custompropertyrules_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_custompropertyrules_write(inputs)
	return de_enum_permission_name_custompropertyrules_write(inputs)
});